/**
 * Calcule une taille responsive basée sur un écran de 1080px
 * @param {number} sizePx - taille en px sur un écran 1080px
 * @param {boolean} [withBorne=false] - active le mode clamp (min -10px, max +10px)
 * @returns {string} - taille responsive (vh ou px)
 */
export default function normalizeSizeVertical(sizePx, withBorne = false) {
    const baseHeight = 1080
    const vhValue = (sizePx / baseHeight) * 100

    if (withBorne) {
        const minPx = sizePx - 10 < 7 ? 7 : sizePx - 10
        const maxPx = sizePx + 10
        return sizePx > 0 ? `clamp(${minPx}px, ${vhValue}vh, ${maxPx}px)` : 0
    }

    return sizePx > 0 ? `${vhValue}vh` : 0
}
